<template>
  <div class="scroll-y custom-scrollbar">
    <ion-row>
      <ion-col size="12" size-md="10" offset-md="1" size-lg="10" offset-lg="1" size-xl="6" offset-xl="3">
        <div class="padding">
          <div class="text-center">
            <h1 class="h1">Kalendarz</h1>
            <div class="list mb-20">

              <div v-if="loading" class="pd-20 text-center" style="width: 100%"><span class="loader red"></span></div>
              <div class="item" v-for="item in calendarsCollection">
                <h2 class="h2 mt-20 mb-0">{{ item.title }}</h2>
                <ion-item v-for="(item,index) in item.details" :key="index">
                  <ion-label>
                    <span class="title">{{ item.title }}</span>
                    <span class="date">{{ item.date }}</span>
                  </ion-label>
                </ion-item>
              </div>
              <div v-if="loading === false && calendarsCollection.length === 0">Brak danych</div>

            </div>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </div>
</template>

<script>
import api from '@/services/Api';

export default {
  name: 'CalendarIndex',
  data() {
    return {
      loading: false,
      calendarsCollection: []
    }
  },
  mounted() {
    this.getCalendars()
  },
  methods: {
    getCalendars() {
      this.loading = true;
      api.get('/api/v1/calendars').then(response => {
        this.loading = false;
        this.calendarsCollection = response.data.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>

ion-item {
  --padding-start: 0;
  --padding-end: 0;
  --inner-padding-start: 0;
  --inner-padding-end: 0;
}

ion-label {
  display: flex !important;
  margin: 0;
  padding: 5px 0;

  .title,
  .date {
    font-size: 13px;
  }

  .title {
    width: 75%;
    overflow: hidden;
  }

  .date {
    width: 25%;
    text-align: right;
  }
}

</style>